"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var date_fns_1 = require("date-fns");
var AdminEventsBatchCreateController = /** @class */ (function () {
    function AdminEventsBatchCreateController($state, BatchCreateService, EventsModel, FlashService) {
        this.$state = $state;
        this.EventsModel = EventsModel;
        this.FlashService = FlashService;
        this.BatchCreateService = BatchCreateService;
        this.endDate = null;
        this.event = BatchCreateService.getEvent();
        this.duplicateSession = this.duplicateSession.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);
    }
    AdminEventsBatchCreateController.prototype.duplicateSession = function () {
        var _this = this;
        var dateObject = this.event.date instanceof Date
            ? this.event.date
            : (0, time_1.dateStringToDate)(this.event.date);
        var timeObject = this.event.time instanceof Date
            ? this.event.time
            : (0, time_1.timeStringToDate)(this.event.time);
        this.EventsModel.batchCreate({
            event: __assign(__assign({}, this.event), {
                date: (0, time_1.toYMD)(dateObject),
                time: (0, date_fns_1.format)(this.event.time, "kk:mm:ss"),
            }),
            end_date: (0, time_1.toYMD)(this.endDate),
            days: this.days,
            location: {
                id: this.event.location.id,
            },
            instructor: {
                id: this.event.instructor.id,
            },
            classroom: {
                id: this.event.classroom.id,
            },
            vehicle: {
                id: this.event.vehicle.id,
            },
        }).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.BatchCreateService.setEvent(null);
            _this.$state.go("drivecoach.admin.calendar", {}, { reload: true });
        });
    };
    AdminEventsBatchCreateController.prototype.updateEndDate = function (newDate) {
        this.endDate = newDate.selected[0];
    };
    return AdminEventsBatchCreateController;
}());
AdminEventsBatchCreateController.$inject = [
    "$state",
    "BatchCreateService",
    "EventsModel",
    "FlashService",
];
exports.default = AdminEventsBatchCreateController;
